import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=7deae5b8&scoped=true&"
import script from "./changePwd.js?vue&type=script&lang=js&"
export * from "./changePwd.js?vue&type=script&lang=js&"
import style0 from "./changePwd.scss?vue&type=style&index=0&id=7deae5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deae5b8",
  null
  
)

export default component.exports